import { jsx as _jsx } from "react/jsx-runtime";
export const Trash = ({ size = 16, className }) => {
    return (_jsx("svg", { fill: "none", viewBox: "0 0 24 24", width: size, height: size, className: className, children: _jsx("path", { fill: "currentColor", d: "M9,3V4H4V6H5V19A2,2 0 0,0 7,21H17A2,2 0 0,0 19,19V6H20V4H15V3H9M7,6H17V19H7V6M9,8V17H11V8H9M13,8V17H15V8H13Z" }) }));
};
